<!-- Header -->
<div mat-dialog-title style="color: #A20000; text-align: center;">
    WARNING
</div>

<!-- Body -->
<mat-dialog-content>

    <div  style="color:#A20000; text-align:center;" translate>
        Changes have been entered but not saved.
    </div>

    <div *ngIf="!validFamily">
        <div style="padding:5px; margin-bottom:15px;">
            A new household does not become official until information for household contacts has been entered.
            If you leave this process now, the information you have entered will be lost.
        </div>
    </div>

    <div *ngIf="validFamily">
        <div style="padding: 5px; margin-bottom: 15px; text-align: center;">
            If you continue without saving, the changes will be lost.
        </div>
        <div *ngIf="hasErrors" style="text-align: center; margin-bottom: 15px;" class="warningText">
            <b>Due to errors, saving is not possible.</b><br />
            Either Continue without Saving <br />
            or select Cancel and correct the errors.
        </div>
    </div>

</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions style="position: sticky; min-width: 430px;">
    <tyl-button *ngIf="validFamily && !hasErrors" [image]="'save.png'" label="Save Family" (clickEvent)="saveFamily()"></tyl-button>

    <div class="footerRight">
        <tyl-button image="next arrow.png" label="Continue without Saving" (clickEvent)="continueWithoutSaving()">
        </tyl-button>
        <tyl-button image="Cancel.png" label="Cancel" (clickEvent)="cancel()"></tyl-button>
    </div>
</mat-dialog-actions>